import React, { useEffect, useMemo, useState } from 'react';
import CustomSelect from '../../lib/form/Select/CustomSelect';
import { useGlobalContext } from '../../../context/GlobalContext';
import styles from './ValidationFiltersMobile.module.scss';
import { SET_ANSWERS_FILTERS } from '../../../actions/types';

export default function ValidationFiltersMobile() {
  const [context, dispatch] = useGlobalContext();
  const [monthsOptions, setMonthsOptions] = useState([]);

  const { lists } = context.questions;
  const { filters } = context?.answers;

  const tagsOptions = useMemo(() => {
    return lists?.tags?.filter(opt => opt !== null)?.sort().map(opt => ({ value: opt, label: opt })) || [];
  }, [lists?.tags]);

  function setFilters(key, value) {
    dispatch({
      type: SET_ANSWERS_FILTERS,
      payload: {
        ...filters,
        page: 1,
        [key]: value
      }
    });
  }

  useEffect(() => {
    if (lists?.oldest && lists?.newest) {
      let options = []
      let value = new Date(new Date(lists?.oldest.date).setDate(1));
      let lastMonth = new Date(new Date(lists?.newest.date).setDate(1));
      while (value < lastMonth) {
        value = new Date(new Date(value).setMonth(value.getMonth() + 1));
        const label = new Intl.DateTimeFormat('fr', { month: 'long', year: 'numeric' }).format(value);
        options.unshift({ label, value })
      }
      options.unshift({ value: "all", label: 'Tous les mois' });
      setMonthsOptions(options);
    }
  }, [lists?.oldest, lists?.newest]);

  return (
    <div className={styles.filters}>
      <div className={styles.filter}>
        <label>Tags</label>
        <CustomSelect
          isMulti
          value={tagsOptions?.filter((t) => filters?.tags.find((s) => s === t.value)) || []}
          handleChange={(val) => setFilters('tags', val.map((v) => v.value))}
          options={tagsOptions}
        />
      </div>
      <div className={styles.filter}>
        <label>Mois</label>
        <CustomSelect
          value={monthsOptions?.find((t) => filters?.month === t.value) || monthsOptions[0]}
          handleChange={(val) => setFilters('month', val.value)}
          options={monthsOptions}
        />
      </div>

    </div>
  )
}
